import { render, staticRenderFns } from "./UcesceTroskova.vue?vue&type=template&id=00fe6206&"
import script from "./UcesceTroskova.vue?vue&type=script&lang=ts&"
export * from "./UcesceTroskova.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports